"use client";

import Image from "next/image";
import Link from "next/link";
import heroSectionLogo from "../../app/hero-section.png";
import { EmailSignupInput } from "./email-signup";

export function HeroSection() {
  return (
    <>
      {/* Center content */}
      <div
        className="hero-center"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          position: "relative",
          zIndex: 10,
          paddingLeft: 24,
          paddingRight: 24,
          gap: 0,
        }}
      >
        {/* Hero mark */}
        <Image
          src={heroSectionLogo}
          alt="KindnessGuild"
          priority
          style={{
            display: "block",
            width: "min(360px, calc(100vw - 64px))",
            height: "auto",
            objectFit: "contain",
            marginBottom: 16,
          }}
        />

        {/* Headline */}
        <h1
          style={{
            fontFamily: "var(--font-heading)",
            fontSize: "clamp(32px, 6vw, 52px)",
            fontWeight: 700,
            lineHeight: 0.95,
            color: "var(--foreground)",
            margin: 0,
            marginBottom: 16,
            textAlign: "center",
            maxWidth: 900,
          }}
        >
          Kindness begins <span style={{ color: "var(--primary)" }}>in your community</span>
        </h1>

        {/* Subtext */}
        <p
          style={{
            fontFamily: "var(--font-heading)",
            fontWeight: "normal",
            fontSize: "clamp(18px, 2vw, 22px)",
            color: "var(--foreground)",
            margin: 0,
            marginBottom: 24,
            lineHeight: 1.4,
            textAlign: "center",
            maxWidth: 620,
            opacity: 0.85,
          }}
        >
          A global community of people coming together, doing things that matter, and making
          neighborhoods kinder. No experience required — just bring your heart.
        </p>

        {/* Email signup */}
        <EmailSignupInput variant="hero" />

        {/* Terms line */}
        <p
          style={{
            fontFamily: "var(--font-inter)",
            fontStyle: "italic",
            fontWeight: "normal",
            fontSize: 15,
            lineHeight: 1.4,
            color: "var(--foreground)",
            margin: "16px 0 0",
            textAlign: "center",
            opacity: 0.75,
            maxWidth: "min(680px, calc(100vw - 48px))",
          }}
        >
          Free for everyone. By continuing, you agree to our{" "}
          <Link
            href="/privacy-and-terms"
            style={{
              color: "var(--primary)",
              textDecoration: "underline",
              textUnderlineOffset: 2,
              whiteSpace: "nowrap",
            }}
          >
            terms.
          </Link>
        </p>
      </div>

      {/* Grain overlay */}
      <div
        aria-hidden="true"
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage: `repeating-linear-gradient(
            0deg,
            rgba(0, 0, 0, 0.02) 0,
            rgba(0, 0, 0, 0.02) 1px,
            transparent 1px,
            transparent 3px
          )`,
          opacity: 0.35,
          pointerEvents: "none",
        }}
      />
    </>
  );
}
